<a #topOfPage id="topOfPage"></a>

<div class="page-content u10g-eoia-web-ag" page-content >
  

  <form [formGroup]="electronicCommunicationForm">
    <prism-ui-container
      is-compact="false"
      key-id="auth-sign-container"
      has-shadow="false"
      variant="default"
      has-no-border-radius="false"
      >
     

      <div class="form-group">
        <div class="item oneCell">
          <prism-ui-copy
            font-size="md"
            font-style="normal"
            font-weight="regular"
            key-id="auth-ack-continue-content-key-id"
            line-height="loose"
            text-decoration="none"
            variant="default"
            [innerHTML]="hasElectronicCommunicationElement?.label"
            >
          </prism-ui-copy>
        </div>
        @if (isGenericDynamicForm && authAckContinueContent) {
          <div class="item oneCell">
            <prism-ui-button
              button-width="content"
              key-id="auth-ack-continue-button"
              size="md"
              variant="text"
              type="button"
              is-waiting="false"
              is-icon-right-aligned="false"
              (click)="onAuthAckContinue($event)"
            >Authorization for use and Release of Information (Continued)</prism-ui-button>
          </div>
        }
        
        <div class="item oneCell">
          <prism-ui-form-field-select
            [isValid]="formControlUtilitiesService.isControlValid(electronicCommunicationForm,'hasElectronicCommunication')"
            [formFieldItemsCount]="radioButtonOptions.length"
            key-id="eCType-name"
            orientation="horizontal"
            hide-legend="true"
            >
            <span slot="error">{{ hasElectronicCommunicationElement?.error }}</span>
          </prism-ui-form-field-select>
          <div class="eCRadioHorizontal">
            @for (eCType of radioButtonOptions; track eCType; let index =
              $index) {
              <div
                id="eCType-{{ index }}"
                slot="input-{{ index + 1 }}"
                >
                <prism-ui-radio-button
                  labelText="{{ eCType.label }}"
                  key-id="eCType-name"
                  ngDefaultControl
                  [name]="eCType.name"
                  formControlName="hasElectronicCommunication"
                  [checked]="electronicCommunicationForm.get('hasElectronicCommunication').value === eCType.name"
                  [isValid]="formControlUtilitiesService.isControlValid(electronicCommunicationForm,'hasElectronicCommunication')"
                  (prismUiRadioButtonOnChange)="logECRadioChangeEvent(eCType.name)"
                  >
                </prism-ui-radio-button>
              </div>
            }
          </div>
        </div>
        @if (electronicCommunicationForm.get('hasElectronicCommunication').value === 'yes') {
          <div class="item oneCell">
            <prism-ui-form-field
              key-id="eCEmail"
                      [isValid]="
                        formControlUtilitiesService.isControlValid(
                           electronicCommunicationForm,
                          'electronicCommunicationEmail'
                        )
                      "
              >
              <span slot="label">{{ electronicCommunicationEmailElement?.label }}</span>
              @if (electronicCommunicationForm.get('electronicCommunicationEmail').pending) {
                <span slot="error">Validating...</span>
              }
              @else if(!electronicCommunicationForm.get('electronicCommunicationEmail').pending
               && electronicCommunicationForm.get('electronicCommunicationEmail').status === 'INVALID'
               && electronicCommunicationForm.get('electronicCommunicationEmail').touched) {
                @if (
                  electronicCommunicationForm.get('electronicCommunicationEmail').errors?.pattern
                  ) {
                  <span slot="error">{{ electronicCommunicationEmailElement?.error }}</span>
                }
                @if (
                  electronicCommunicationForm.get('electronicCommunicationEmail').errors?.invalidEmail
                  ) {
                  <span slot="error">{{ electronicCommunicationEmailElement?.error }}</span>
                }
              
                @if (
                  electronicCommunicationForm
                  .get('electronicCommunicationEmail')
                  .hasError('required')
                  ) {
                  <span slot="error">{{ electronicCommunicationEmailElement?.error }}</span>
                }
              }
              <prism-ui-input-email
                slot="input"
                is-required="true"
                ngDefaultControl
                formControlName="electronicCommunicationEmail"
                name="electronicCommunicationEmail"
                [formGroup]="electronicCommunicationForm"
                key-id="electronicCommunicationEmail"
                placeholder="{{ electronicCommunicationEmailElement?.placeholder }}"
                [attr.default-value]="electronicCommunicationForm.get('electronicCommunicationEmail')?.value"
                        [isValid]="
                          formControlUtilitiesService.isControlValid(
                            electronicCommunicationForm,
                            'electronicCommunicationEmail'
                          )
                        "
                autocomplete="new-password"
                (focusout)="emailLeaveEvent($event)"
                autofill="off"
              ></prism-ui-input-email>
            </prism-ui-form-field>
          </div>
        }


      </div>
    </prism-ui-container>
    <div class="row topPadding">
        @if (showBackButton) {
          <prism-ui-button-group
            key-id="continue-cancel-button-group"
            buttons-count="2"
            spacing="default"
            class="ccFlexbox"
          >
            <!-- Show Back button for step 6, Cancel button for other steps -->
            <prism-ui-button
              button-width="full"
              slot="1"
              key-id="back-button"
              size="md"
              variant="secondary"
              type="button"
              (click)="onBack()"
            >Cancel</prism-ui-button>
          
            <prism-ui-button
              button-width="full"
              slot="2"
              key-id="submit-button"
              size="md"
              variant="primary"
              type="button"
              (click)="onSubmitButtonClick($event)"
            >Submit Statement</prism-ui-button>

          </prism-ui-button-group>
        }
        @if (!showBackButton) {  
          <prism-ui-button-group
            key-id="continue-cancel-button-group"
            buttons-count="2"
            spacing="default"
            class="ccFlexbox"
          >
            <prism-ui-button
              button-width="full"
              slot="1"
              key-id="cancel-button"
              size="md"
              variant="secondary"
              type="button"
              (click)="onCancel()"
            >Cancel</prism-ui-button>

            <prism-ui-button
              button-width="full"
              slot="2"
              key-id="submit-button"
              size="md"
              variant="primary"
              type="button"
              (click)="onSubmitButtonClick($event)"
            >Submit Statement</prism-ui-button>

          </prism-ui-button-group>
        }
        </div>
  </form>
</div>

@if (formSubmitted) {
  <div class="page-loader">
    <prism-ui-loader
      has-logo="false"
      is-reverse="false"
      key-id="page-loader"
      size="md"
      >
    </prism-ui-loader>
    <prism-ui-copy
      font-size="md"
      font-style="normal"
      font-weight="regular"
      key-id="test-key-id"
      line-height="medium"
      text-decoration="none"
      variant="default"
      >
      <span>Please wait while we process your request</span>
    </prism-ui-copy>
  </div>
}

<prism-ui-modal key-id="auth-ack-continue-modal" has-dark-overlay="true">
  <prism-ui-heading
    slot="modal-header"
    key-id="auth-ack-continue-modal"
    font-size="sm"
    font-weight="strong"
    >{{authAckContinueContentTitle}}</prism-ui-heading
    >
    <div slot="modal-body" class="modal-body">
      <prism-ui-copy
        key-id="auth-ack-continue-modal"
        [innerHTML]="authAckContinueContentBody"
        >
      </prism-ui-copy>
    </div>
</prism-ui-modal>

<prism-ui-modal key-id="error-modal" has-dark-overlay="true">
  <prism-ui-heading
    slot="modal-header"
    key-id="error-modal"
    font-size="sm"
    font-weight="strong"
    >{{errorModalContentHeading}}</prism-ui-heading
    >
    <prism-ui-copy
      slot="modal-body"
      key-id="error-modal"
      >
      {{errorModalContentBody}}
    </prism-ui-copy>
    <div slot="modal-footer">
      <div class="modalButtonStyling">
        <prism-ui-button
          button-width="full"
          key-id="cancel-button"
          size="md"
          variant="secondary"
          type="button"
          is-icon-right-aligned="false"
          (click)="onCancelModal('prism-ui-modal-error-modal')"
        >Cancel</prism-ui-button>
        <prism-ui-button class="leftPaddingSmall"
          button-width="full"
          key-id="continue-button"
          size="md"
          variant="primary"
          type="button"
          is-icon-right-aligned="false"
          (click)="leaveAnyway()"
        >Leave Anyway</prism-ui-button>
      </div>
    </div>
  </prism-ui-modal>